import React from "react";
import { useParams } from "react-router-dom";
import cakeimg1 from "../Sevendays Bakery/cakeimg (1).jpg";
import cakeimg4 from "../Sevendays Bakery/cakeimg (4).jpg";
import cakeimg5 from "../Sevendays Bakery/cakeimg (5).jpg";
import cakeimg6 from "../Sevendays Bakery/cakeimg (6).jpg";
import cakeimg7 from "../Sevendays Bakery/cakeimg (7).jpg";
import cakeimg8 from "../Sevendays Bakery/cakeimg (8).jpg";
import cakeimg9 from "../Sevendays Bakery/cakeimg (9).jpg";
import cakeimg10 from "../Sevendays Bakery/cakeimg (10).jpg";
import cakeimg11 from "../Sevendays Bakery/cakeimg (11).jpg";
import cakeimg12 from "../Sevendays Bakery/cakeimg (12).jpg";
import cakeimg13 from "../Sevendays Bakery/cakeimg (13).jpg";

const Productlist = () => {
  const { id: slug } = useParams();
  const categoryId = parseInt(slug);

  const data = [
    {
      id: 1,
      title: "Cakes",
      productlist: [
        { id: 1, name: "Chocolate Cake", image: cakeimg1 },
        { id: 2, name: "Fruit Tart", image: cakeimg4 },
        { id: 3, name: "Macarons", image: cakeimg5 },
        { id: 4, name: "Cupcakes", image: cakeimg6 },
        { id: 5, name: "Chocolate Cake", image: cakeimg7 },
        { id: 6, name: "Fruit Tart", image: cakeimg8 },
        { id: 7, name: "Macarons", image: cakeimg9 }
      ]
    },
    {
      id: 4,
      title: "Cakes1",
      productlist: [
        { id: 1, name: "Chocolate Cake", image: cakeimg10 },
        { id: 2, name: "Fruit Tart", image: cakeimg11 },
        { id: 3, name: "Macarons", image: cakeimg5 },
        { id: 4, name: "Cupcakes", image: cakeimg6 },
        { id: 5, name: "Chocolate Cake", image: cakeimg12 },
        { id: 6, name: "Fruit Tart", image: cakeimg13 },
        { id: 7, name: "Macarons", image: cakeimg9 }
      ]
    }
  ];

  const selectedCategory = data.find((item) => item.id === categoryId);

  if (!selectedCategory) {
    return <div className="productlist-container">No products found for this category.</div>;
  }

  return (
    <div className="productlist-container">
      <h2 className="productlist-title">{selectedCategory.title}</h2>
      <div className="productlist-grid">
        {selectedCategory.productlist.map((product) => (
          <div key={product.id} className="product-card">
            <img src={product.image} alt={product.name} className="product-image" />
            <h4 className="product-name">{product.name}</h4>
            <a
              href={`https://wa.me/919666696905?text=Hi, I would like to order: ${encodeURIComponent(product.name)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-order-btn"
            >
              Order Now via WhatsApp
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Productlist;
